import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Button, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { ContentHeading } from '../../../../components/common/ContentHeading/index.js';
import { loginSourceSelector } from '../../../../core/sourceData/sourceDataSlice.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { RegistrationWithEmailForm } from '../../../Registration/components/RegistrationWithEmailForm/index.js';
import { RegistrationAlert } from '../../../Registration/components/RegistrationAlert/index.js';
import { trackButtonClick, trackModalView } from '../../../../tracking/index.js';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { useTranslatedSourceOverrideLabel } from '../../../../hooks/useTranslatedLabel.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../twoStepLoginRegistrationSlice.js';
import { updateTwoStepActiveState } from '../../twoStepLoginRegistrationSlice.js';
import { TwoStepConsent } from '../../components/TwoStepConsent/index.js';
import { registrationConsentPositionSelector } from '../../../../core/siteConfig/siteConfigSlice.js';
import { INITIAL_TRACKING_DELAY } from '../../../../constants/tracking.js';
export const TwoStepRegistration = () => {
    const dispatch = useAppDispatch();
    const loginSource = useAppSelector(loginSourceSelector);
    const registrationConsentPosition = useAppSelector(registrationConsentPositionSelector);
    const { t } = useTranslation();
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    useEffect(() => {
        // setTimeout to keep correct tracking events order
        setTimeout(() => dispatch(sendGlobalTrackingThunk(trackModalView, { componentState })), INITIAL_TRACKING_DELAY);
    }, []);
    const headerLabel = useSourceOverrideLabel('twoStepLoginRegistration.registration.header');
    const onShowAllOptions = (e) => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'showAllOptions',
            componentState,
        }));
        e.preventDefault();
        dispatch(updateTwoStepActiveState('accountIdentifier'));
    };
    // For successful registration registrationSlice redirect to candidate/register/success page
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "registration-form", children: [_jsx(ContentHeading, { label: headerLabel }), _jsx(RegistrationAlert, {}), _jsx(RegistrationWithEmailForm, {}), _jsx(Button, { variant: "link", a11yLabel: "back-to-email-address", "data-testid": "back-to-email-address-link", onClick: (e) => onShowAllOptions(e), children: t('loginregistration.twoStepLoginRegistration.registration.backLink') }), registrationConsentPosition === 'bottom' && (_jsx(TwoStepConsent, { label: t('loginregistration.twoStepLoginRegistration.registration.legalNote'), variant: "registration" }))] }));
};
//# sourceMappingURL=TwoStepRegistration.js.map